<template>
  <div class="card-guide">
    <div class="card-guide-body">
      <div class="d-flex justify-content-between">
        <span class="add-plans" @click="showAddPlan">+ ADD PLAN</span>
        <span class="search">
          <label>
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.3335 3.16659C4.75617 3.16659 2.66683 5.25592 2.66683 7.83325C2.66683 10.4106 4.75617 12.4999 7.3335 12.4999C9.91083 12.4999 12.0002 10.4106 12.0002 7.83325C12.0002 5.25592 9.91083 3.16659 7.3335 3.16659ZM1.3335 7.83325C1.3335 4.51954 4.01979 1.83325 7.3335 1.83325C10.6472 1.83325 13.3335 4.51954 13.3335 7.83325C13.3335 11.147 10.6472 13.8333 7.3335 13.8333C4.01979 13.8333 1.3335 11.147 1.3335 7.83325Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.6284 11.1286C10.8887 10.8683 11.3108 10.8683 11.5712 11.1286L14.4712 14.0286C14.7315 14.289 14.7315 14.7111 14.4712 14.9714C14.2108 15.2318 13.7887 15.2318 13.5284 14.9714L10.6284 12.0714C10.368 11.8111 10.368 11.389 10.6284 11.1286Z"
                fill="#B3C2CB"
              />
            </svg>
            <input
              type="search"
              class="search-input"
              placeholder="Search Plan"
              v-model="searchStr"
            />
          </label>
        </span>
      </div>

      <div class="faqs" role="tablist">
        <b-card no-body class="mb-1" v-for="(plan, i) in plans" :key="i">
          <b-card-header
            header-tag="header"
            :class="{ active: activeCollapse == 'faq' + i }"
            role="tab"
          >
            <b-button
              class="btn-collapse"
              block
              variant="collapse"
              v-b-toggle="'faq' + i"
              >{{ plan.title }}
            </b-button>
            <span
              class="edit"
              @click="showEditPlan(i)"
              v-b-popover.top.hover="'Edit'"
              ><svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.6665 3.33333C2.48969 3.33333 2.32012 3.40357 2.1951 3.5286C2.07008 3.65362 1.99984 3.82319 1.99984 4V13.3333C1.99984 13.5101 2.07007 13.6797 2.1951 13.8047C2.32012 13.9298 2.48969 14 2.6665 14H11.9998C12.1766 14 12.3462 13.9298 12.4712 13.8047C12.5963 13.6797 12.6665 13.5101 12.6665 13.3333V9.77333C12.6665 9.40514 12.965 9.10667 13.3332 9.10667C13.7014 9.10667 13.9998 9.40514 13.9998 9.77333V13.3333C13.9998 13.8638 13.7891 14.3725 13.4141 14.7475C13.039 15.1226 12.5303 15.3333 11.9998 15.3333H2.6665C2.13607 15.3333 1.62736 15.1226 1.25229 14.7475C0.877218 14.3725 0.666504 13.8638 0.666504 13.3333V4C0.666504 3.46957 0.877217 2.96086 1.25229 2.58579C1.62736 2.21071 2.13607 2 2.6665 2H6.2265C6.59469 2 6.89317 2.29848 6.89317 2.66667C6.89317 3.03486 6.59469 3.33333 6.2265 3.33333H2.6665Z"
                  fill="#B3C2CB"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.5284 0.86201C11.7888 0.601661 12.2109 0.601661 12.4712 0.86201L15.1379 3.52868C15.3983 3.78903 15.3983 4.21114 15.1379 4.47149L8.47124 11.1382C8.34622 11.2632 8.17665 11.3334 7.99984 11.3334H5.33317C4.96498 11.3334 4.6665 11.0349 4.6665 10.6667V8.00008C4.6665 7.82327 4.73674 7.6537 4.86177 7.52868L11.5284 0.86201ZM5.99984 8.27622V10.0001H7.7237L13.7237 4.00008L11.9998 2.27622L5.99984 8.27622Z"
                  fill="#B3C2CB"
                />
              </svg>
            </span>
            <span
              class="delete"
              @click="showDeletePlan(i)"
              v-b-popover.top.hover="'Delete'"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.3335 4.00008C1.3335 3.63189 1.63197 3.33341 2.00016 3.33341H14.0002C14.3684 3.33341 14.6668 3.63189 14.6668 4.00008C14.6668 4.36827 14.3684 4.66675 14.0002 4.66675H2.00016C1.63197 4.66675 1.3335 4.36827 1.3335 4.00008Z"
                  fill="#EF5C4A"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.66683 2.00008C6.49002 2.00008 6.32045 2.07032 6.19543 2.19534C6.0704 2.32037 6.00016 2.48994 6.00016 2.66675V3.33341H10.0002V2.66675C10.0002 2.48994 9.92992 2.32037 9.8049 2.19534C9.67988 2.07032 9.51031 2.00008 9.3335 2.00008H6.66683ZM11.3335 3.33341V2.66675C11.3335 2.13631 11.1228 1.62761 10.7477 1.25253C10.3726 0.877462 9.86393 0.666748 9.3335 0.666748H6.66683C6.1364 0.666748 5.62769 0.877462 5.25262 1.25253C4.87754 1.62761 4.66683 2.13631 4.66683 2.66675V3.33341H3.3335C2.96531 3.33341 2.66683 3.63189 2.66683 4.00008V13.3334C2.66683 13.8638 2.87754 14.3726 3.25262 14.7476C3.62769 15.1227 4.1364 15.3334 4.66683 15.3334H11.3335C11.8639 15.3334 12.3726 15.1227 12.7477 14.7476C13.1228 14.3726 13.3335 13.8638 13.3335 13.3334V4.00008C13.3335 3.63189 13.035 3.33341 12.6668 3.33341H11.3335ZM4.00016 4.66675V13.3334C4.00016 13.5102 4.0704 13.6798 4.19543 13.8048C4.32045 13.9298 4.49002 14.0001 4.66683 14.0001H11.3335C11.5103 14.0001 11.6799 13.9298 11.8049 13.8048C11.9299 13.6798 12.0002 13.5102 12.0002 13.3334V4.66675H4.00016Z"
                  fill="#EF5C4A"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.66683 6.66675C7.03502 6.66675 7.3335 6.96522 7.3335 7.33341V11.3334C7.3335 11.7016 7.03502 12.0001 6.66683 12.0001C6.29864 12.0001 6.00016 11.7016 6.00016 11.3334V7.33341C6.00016 6.96522 6.29864 6.66675 6.66683 6.66675Z"
                  fill="#EF5C4A"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.3335 6.66675C9.70169 6.66675 10.0002 6.96522 10.0002 7.33341V11.3334C10.0002 11.7016 9.70169 12.0001 9.3335 12.0001C8.96531 12.0001 8.66683 11.7016 8.66683 11.3334V7.33341C8.66683 6.96522 8.96531 6.66675 9.3335 6.66675Z"
                  fill="#EF5C4A"
                />
              </svg>
            </span>
            <span class="chevron" v-b-toggle="'faq' + i">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.293 9.29297L12 13.586L7.70697 9.29297L6.29297 10.707L12 16.414L17.707 10.707L16.293 9.29297Z"
                  fill="#B3C2CB"
                />
              </svg>
            </span>
          </b-card-header>
          <b-collapse :id="'faq' + i" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <div class="details">
                <div class="price">
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.00016 0.5C8.36835 0.5 8.66683 0.798477 8.66683 1.16667V15.8333C8.66683 16.2015 8.36835 16.5 8.00016 16.5C7.63197 16.5 7.3335 16.2015 7.3335 15.8333V1.16667C7.3335 0.798477 7.63197 0.5 8.00016 0.5Z"
                        fill="#65EA82"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.21218 4.04535C4.77478 3.48274 5.53785 3.16667 6.3335 3.16667H11.3335C11.7017 3.16667 12.0002 3.46514 12.0002 3.83333C12.0002 4.20152 11.7017 4.5 11.3335 4.5H6.3335C5.89147 4.5 5.46755 4.67559 5.15498 4.98816C4.84242 5.30072 4.66683 5.72464 4.66683 6.16667C4.66683 6.60869 4.84242 7.03262 5.15498 7.34518C5.46755 7.65774 5.89147 7.83333 6.3335 7.83333H9.66683C10.4625 7.83333 11.2255 8.1494 11.7882 8.71201C12.3508 9.27462 12.6668 10.0377 12.6668 10.8333C12.6668 11.629 12.3508 12.392 11.7882 12.9547C11.2255 13.5173 10.4625 13.8333 9.66683 13.8333H4.00016C3.63197 13.8333 3.3335 13.5349 3.3335 13.1667C3.3335 12.7985 3.63197 12.5 4.00016 12.5H9.66683C10.1089 12.5 10.5328 12.3244 10.8453 12.0118C11.1579 11.6993 11.3335 11.2754 11.3335 10.8333C11.3335 10.3913 11.1579 9.96738 10.8453 9.65482C10.5328 9.34226 10.1089 9.16667 9.66683 9.16667H6.3335C5.53785 9.16667 4.77478 8.8506 4.21218 8.28799C3.64957 7.72538 3.3335 6.96232 3.3335 6.16667C3.3335 5.37102 3.64957 4.60796 4.21218 4.04535Z"
                        fill="#65EA82"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0">
                        <rect
                          width="16"
                          height="16"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  <span>${{ plan.price }}</span>
                </div>
                <div class="time">
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.99984 2.50008C4.68613 2.50008 1.99984 5.18637 1.99984 8.50008C1.99984 11.8138 4.68613 14.5001 7.99984 14.5001C11.3135 14.5001 13.9998 11.8138 13.9998 8.50008C13.9998 5.18637 11.3135 2.50008 7.99984 2.50008ZM0.666504 8.50008C0.666504 4.44999 3.94975 1.16675 7.99984 1.16675C12.0499 1.16675 15.3332 4.44999 15.3332 8.50008C15.3332 12.5502 12.0499 15.8334 7.99984 15.8334C3.94975 15.8334 0.666504 12.5502 0.666504 8.50008Z"
                      fill="#557EFB"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.99984 3.83341C8.36803 3.83341 8.6665 4.13189 8.6665 4.50008V8.08806L10.9646 9.23713C11.294 9.40179 11.4274 9.80224 11.2628 10.1316C11.0981 10.4609 10.6977 10.5944 10.3684 10.4297L7.70169 9.09637C7.47584 8.98344 7.33317 8.7526 7.33317 8.50008V4.50008C7.33317 4.13189 7.63165 3.83341 7.99984 3.83341Z"
                      fill="#557EFB"
                    />
                  </svg>
                  <span>{{ plan.duration }} mins</span>
                </div>
              </div>
              <b-card-text>{{ plan.details }}</b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <modal :id="planModal">
        <div class="add-plan" v-if="!del">
          <span class="close-icon" @click="cancelAction">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>

          <h3>{{ add ? "Add" : "Edit" }} Plan</h3>
          <div class="h-18"></div>
          <b-form-group label="Title">
            <b-form-input
              type="text"
              required
              v-model="plan.title"
              placeholder="Enter your plan title here"
            ></b-form-input>
          </b-form-group>
          <b-form-group class="textarea-scroll" label="Plan Summary">
            <b-form-textarea
              id="summary"
              rows="3"
              no-resize
              v-model="plan.summary"
              placeholder="Enter your plan summary here"
              @focus="limitSummaryWords"
            ></b-form-textarea>
            <span class="counter">{{ plan.summary.length }}/150</span>
          </b-form-group>
          <b-form-group class="textarea-scroll" label="Plan Details">
            <b-form-textarea
              id="details"
              rows="5"
              no-resize
              v-model="plan.details"
              placeholder="Enter your plan details here"
              @focus="limitDetailsWords"
            ></b-form-textarea>
            <span class="counter">{{ plan.details.length }}/500</span>
          </b-form-group>
          <div class="digtim">
            <b-form-group label="Price">
              <span class="pre">$</span>
              <b-form-input
                type="number"
                required
                v-model="plan.price"
              ></b-form-input>
            </b-form-group>

            <b-form-group label="Duration">
              <span class="post">mins</span>
              <b-form-input
                type="number"
                required
                v-model="plan.duration"
              ></b-form-input>
            </b-form-group>
          </div>
          <label class="notification">
            <div class="toggler" :class="[showCharity ? 'bg' : '']">
              <div class="slider" :class="[showCharity ? 'btns' : '']"></div>
            </div>
            <div class="notification-content">
              <h6>
                Add Charity
              </h6>
            </div>
            <input type="checkbox" class="invisible" v-model="showCharity" />
          </label>
          <b-form-group v-if="showCharity">
            <b-form-select
              v-model="plan.charity"
              :options="charityList"
            ></b-form-select>
          </b-form-group>

          <div class="upload">
            <div class="upload-video" v-if="!plan.video">
              Upload your Video
            </div>
            <div>
              <b-button
                :disabled="!plan.video && uploadingVideo"
                class="upload-btn"
                :class="plan.video ? 'video' : 'no-video'"
              >
                <span class="ico" v-if="!uploadingVideo">
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M20.048 5.09236C20.3255 5.2352 20.5 5.52118 20.5 5.83334V14.1667C20.5 14.4788 20.3255 14.7648 20.048 14.9076C19.7704 15.0505 19.4363 15.0262 19.1823 14.8448L13.349 10.6781C13.13 10.5217 13 10.2691 13 10C13 9.73088 13.13 9.47832 13.349 9.32189L19.1823 5.15523C19.4363 4.97379 19.7704 4.94953 20.048 5.09236ZM15.2671 10L18.8333 12.5473V7.45266L15.2671 10Z"
                        :fill="plan.video ? '#fff' : '#557EFB'"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M3 4.99967C2.53976 4.99967 2.16667 5.37277 2.16667 5.83301V14.1663C2.16667 14.6266 2.53976 14.9997 3 14.9997H12.1667C12.6269 14.9997 13 14.6266 13 14.1663V5.83301C13 5.37277 12.6269 4.99967 12.1667 4.99967H3ZM0.5 5.83301C0.5 4.4523 1.61929 3.33301 3 3.33301H12.1667C13.5474 3.33301 14.6667 4.4523 14.6667 5.83301V14.1663C14.6667 15.5471 13.5474 16.6663 12.1667 16.6663H3C1.61929 16.6663 0.5 15.5471 0.5 14.1663V5.83301Z"
                        :fill="plan.video ? '#fff' : '#557EFB'"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0">
                        <rect
                          width="20"
                          height="20"
                          fill="white"
                          transform="translate(0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                <span
                  class="btn-content"
                  v-if="!plan.video && !uploadingVideo"
                  @click="triggerChooseVideo"
                >
                  Upload a Video
                  <input
                    id="guide-plan-video"
                    type="file"
                    style="visibility: hidden"
                    @change="uploadGuidePlanVideo($event, profile)"
                  />
                </span>
                <span class="btn-content" v-if="uploadingVideo && !plan.video">
                  <b-spinner small></b-spinner>
                  Uploading... {{ progress }}%
                </span>
                <span
                  class="watch-video"
                  v-if="plan.video && plan.video.videoId"
                  @click="$bvModal.show(guideVideo)"
                >
                  Watch Video
                </span>
              </b-button>
            </div>
          </div>

          <b-form-checkbox
            id="audioOnly"
            v-model="plan.type"
            name="audioOnly"
            value="audio"
          >
            Audio
          </b-form-checkbox>
          <b-form-checkbox
            id="audioVideo"
            v-model="plan.type"
            name="audioVideo"
            value="audiovideo"
          >
            Audio & Video
          </b-form-checkbox>
          <b-form-checkbox
            id="messaging"
            v-model="plan.type"
            name="messaging"
            value="messaging"
          >
            Messaging
          </b-form-checkbox>
          <span class="small-check">Default will be video &amp; audio</span>
          <div class="foot">
            <div class="d-flex justify-content-between">
              <b-button variant="light btn-simple" @click="cancelAction">
                Cancel
              </b-button>
              <b-button
                variant="primary btn-round-fill"
                v-if="add"
                @click="addPlan"
                :disabled="
                  plan.summary.trim().length > 0 &&
                  plan.details.trim().length > 0 &&
                  plan.title.trim().length > 0 &&
                  plan.duration > 0 &&
                  plan.price >= 0 &&
                  !uploadingVideo
                    ? false
                    : true
                "
              >
                Add
              </b-button>
              <b-button
                variant="primary btn-round-fill"
                @click="editPlan"
                v-else
                :disabled="
                  plan.summary.trim().length > 0 &&
                  plan.details.trim().length > 0 &&
                  plan.title.trim().length > 0 &&
                  plan.duration > 0 &&
                  plan.price >= 0 &&
                  !uploadingVideo
                    ? false
                    : true
                "
              >
                Update
              </b-button>
            </div>
          </div>
        </div>
        <div class="add-plan del-faq" v-else>
          <span class="close-icon" @click="$bvModal.hide(planModal)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <h3>Delete Plan</h3>
          <div class="warning-msg">
            <p>
              Are you sure want to delete
              <strong>{{ plans[activeIndex].title }}</strong> plan?
            </p>
          </div>
          <div class="d-flex justify-content-between">
            <b-button class="danger btn-round-fill" @click="deletePlan">
              Yes! Delete
            </b-button>
            <b-button class="btn-simple" @click="hideDeletePlan">
              No! back
            </b-button>
          </div>
        </div>
      </modal>
    </div>
    <TutorialModal
      :id="guideVideo"
      :video="{ videoId: plan && plan.video ? plan.video.videoId : '' }"
    />
  </div>
</template>

<script>
import Modal from "@/components/common/modal";
import VideoHandling from "@/mixins/VideoHandling";

export default {
  data() {
    return {
      planModal: "guide-plan-modal",
      guideVideo: "plan-video",
      add: true,
      del: false,
      activeIndex: -1,
      activeCollapse: -1,
      isJustShown: false,
      searchStr: "",
      showCharity: false,
      plan: {
        title: "",
        summary: "",
        details: "",
        price: 0,
        duration: "",
        charity: "",
        video: null,
        type: ["audiovideo"]
      },
      charityList: [
        {
          value: "",
          text: "Please select an option (If you wish to donate)"
        }
      ],
      allPlans: this.profile._dashboards.guide.plans
        ? JSON.parse(JSON.stringify(this.profile._dashboards.guide.plans))
        : []
    };
  },
  components: {
    Modal
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  mixins: [VideoHandling],
  mounted() {
    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      if (this.activeCollapse == collapseId) {
        this.activeCollapse = -1;
      }

      if (isJustShown) {
        this.activeCollapse = collapseId;
      }
    });
    this.$root.$on("guidePlanVideoUploaded", video => {
      this.plan.video = video;
    });
    this.getCharities();
  },
  computed: {
    plans() {
      if (this.searchStr.trim() == "") return this.allPlans;
      return this.allPlans.filter(plan => {
        return (
          plan.title
            .toLowerCase()
            .includes(this.searchStr.toLowerCase().trim()) ||
          plan.summary
            .toLowerCase()
            .includes(this.searchStr.toLowerCase().trim()) ||
          plan.details
            .toLowerCase()
            .includes(this.searchStr.toLowerCase().trim()) ||
          plan.type.toLowerCase().includes(this.searchStr.toLowerCase().trim())
        );
      });
    }
  },
  methods: {
    limitSummaryWords() {
      document.getElementById("summary").setAttribute("maxlength", 300);
    },
    limitDetailsWords() {
      document.getElementById("details").setAttribute("maxlength", 300);
    },
    getCharities() {
      this.$store.dispatch("listings/getListCharities").then(res => {
        this.charityList.push(...res);
      });
    },
    triggerChooseVideo() {
      document.getElementById("guide-plan-video").click();
    },
    uploadGuidePlanVideo(event) {
      let file = event.target.files[0];
      let name = `guide_plan_${this.profile.userId}_${(Date.now() / 1000) | 0}`;
      let description = `${this.profile.firstname}'s Guide Plan Video.`;
      this.uploadVideo(file, name, description).then(video => {
        this.plan.video = video;
      });
    },
    showAddPlan() {
      this.del = false;
      this.add = true;
      this.resetForm();
      this.$bvModal.show(this.planModal);
    },
    showEditPlan(i) {
      this.del = false;
      this.add = false;
      this.activeIndex = i;
      this.plan.title = this.plans[i].title;
      this.plan.summary = this.plans[i].summary;
      this.plan.details = this.plans[i].details;
      this.plan.price = this.plans[i].price;
      this.plan.duration = this.plans[i].duration;
      this.plan.charity = this.plans[i].charity;
      this.plan.type = this.plans[i].type;
      this.plan.video = this.plans[i].video;
      if (this.plans[i].charity) this.showCharity = true;
      this.$bvModal.show(this.planModal);
    },
    showDeletePlan(i) {
      this.del = true;
      this.activeIndex = i;
      this.$bvModal.show(this.planModal);
    },
    addPlan() {
      this.plans.push({
        id: this.getPlanId(5),
        title: this.plan.title,
        summary: this.plan.summary,
        details: this.plan.details,
        price: this.plan.price,
        duration: this.plan.duration,
        charity: this.showCharity ? this.plan.charity : null,
        type: this.plan.type,
        video: this.plan.video,
        _created_at: new Date()
      });
      this.$bvModal.hide(this.planModal);
      this.resetForm();
      this.saveChanges();
    },
    editPlan() {
      this.plans[this.activeIndex].title = this.plan.title;
      this.plans[this.activeIndex].summary = this.plan.summary;
      this.plans[this.activeIndex].details = this.plan.details;
      this.plans[this.activeIndex].price = this.plan.price;
      this.plans[this.activeIndex].duration = this.plan.duration;
      this.plans[this.activeIndex].charity = this.showCharity
        ? this.plan.charity
        : null;
      this.plans[this.activeIndex].type = this.plan.type;
      this.plans[this.activeIndex].video = this.plan.video;
      this.$bvModal.hide(this.planModal);
      this.resetForm();
      this.saveChanges();
    },
    deletePlan() {
      this.plans.splice(this.activeIndex, 1);
      this.$bvModal.hide(this.planModal);
      this.saveChanges();
    },
    hideDeletePlan() {
      this.$bvModal.hide(this.planModal);
    },
    cancelAction() {
      this.resetForm();
      this.$bvModal.hide(this.planModal);
    },
    getNested({ obj, def }, ...args) {
      let truthy = args.reduce((obj, level) => obj && obj[level], obj);
      if (truthy) {
        let val = Array.isArray(truthy) ? truthy : def;
        return val;
      } else {
        return def;
      }
    },
    getPlanId(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    saveChanges() {
      let dataToUpdateTags = {
        guide: {
          plans: this.plans
        }
      };

      if (dataToUpdateTags) {
        this.$store
          .dispatch("user/updateProfileDashboardGuide", dataToUpdateTags)
          .then(res => {
            if (res) {
              this.$store.dispatch("user/getProfile").then(() => {
                this.$store.dispatch("user/showNotification", {
                  title: "Plans Updated Successfully",
                  description:
                    "Users will not see this info until you Publish.",
                  variant: "success"
                });
              });
            }
          });
      }
    },
    resetForm() {
      this.plan = {
        title: "",
        summary: "",
        details: "",
        price: 0,
        duration: "",
        charity: "",
        video: null,
        type: ["audiovideo"]
      };
      this.showCharity = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.upload_file {
  width: 129px;
  height: 40px;
  background: #557efb;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.07);
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Nunito;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
  cursor: pointer;
  .ico {
    margin-right: 9px;
  }
}
.small-check {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
  margin-left: 24px;
}
.progress {
  margin-bottom: 10px;
}
.custom-control-label {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #474d52;
}
.digtim {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
}
.bv-no-focus-ring {
  position: relative;
  .pre {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #8d99a0;
  }
  .post {
    position: absolute;
    right: 15px;
    top: 50%;
    color: #8d99a0;
    transform: translateY(-50%);
  }
  input {
    padding-left: 30px;
  }
}
.add-plans {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: #557efb;
  cursor: pointer;
  position: relative;
}
.add-plan {
  .foot {
    margin-top: 24px;
    border-top: 1px solid #dddddd;
    padding: 24px 0 10px 0;
  }
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
}
.del-faq {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-guide {
  box-shadow: none;
}
.faqs {
  margin-top: 20px;
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .details {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      & > div {
        margin-right: 18px;
        display: flex;
        align-items: center;
        svg {
          margin-right: 5px;
        }
      }
    }
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .delete {
      display: none;
      cursor: pointer;
    }
    .btn-collapse {
      padding: 24px;
      text-align: left;
      box-shadow: none;
    }
    &.active {
      grid-template-columns: 1fr 30px 30px 30px;
      .edit,
      .delete {
        display: block;
      }
    }

    border: none;
    box-shadow: none;
    background: none;
  }
  .card-body {
    padding-top: 0;
  }
}
.notification {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;
  .disabled {
    opacity: 0.7;
  }
  .notification-content {
    margin-top: 11px;
    margin-left: 14px;
    cursor: pointer;
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;

      color: #8d99a0;
      margin: 0;
    }
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;

      display: flex;
      align-items: center;
      color: #474d52;
      @media (max-width: 874px) {
        margin-bottom: 0px;
      }
    }
  }
  .toggler {
    @media (max-width: 874px) {
      margin-bottom: 10px;
      margin-left: 15px;
    }
    cursor: pointer;
    position: relative;
    display: inline-block;
    width: 46.5px;
    height: 24px;
    background: #f3f6f9;
    border-radius: 18px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  .slider {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background: #b3c2cb;
    box-shadow: 0px 3px 9px #c4c4c4;

    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
  .bg {
    background: rgba(85, 126, 251, 0.1);
  }
  .btns {
    left: 50%;
    background: #557efb;
    box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}
.counter {
  font-size: 12px;
  float: right;
}
.upload {
  margin-bottom: 1rem;
  .upload-video {
    margin-top: 15px;
    font-family: Nunito;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    color: #8d99a0;
  }
  .upload-btn {
    margin-top: 16px;
    width: 208px;
    height: 40px;
    border-radius: 100px;
    border: none;
    outline: none !important;
    .ico {
      margin-right: 5px;
    }
    .btn-content {
      margin-top: 5px;
      font-family: Nunito;
      font-style: normal;
      font-weight: 800;
      font-size: 16px;
      line-height: 22px;
      color: #557efb;
    }
  }
  .video {
    color: #fff !important;
    background-color: #557efb !important;
  }
  .no-video {
    color: #557efb;
    background: rgba(85, 126, 251, 0.1);
  }
  .watch-video {
    margin-top: 5px;
    font-family: Nunito;
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;
  }
}
</style>
